export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.13704f37.worker.js");
}
